import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Report\ExportReportController::__invoke
* @see app/Http/Controllers/Report/ExportReportController.php
* @route '/api/reports/{report}/export'
*/
const ExportReportController = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ExportReportController.url(args, options),
    method: 'get',
})

ExportReportController.definition = {
    methods: ["get","head"],
    url: '/api/reports/{report}/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Report\ExportReportController::__invoke
* @see app/Http/Controllers/Report/ExportReportController.php
* @route '/api/reports/{report}/export'
*/
ExportReportController.url = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return ExportReportController.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Report\ExportReportController::__invoke
* @see app/Http/Controllers/Report/ExportReportController.php
* @route '/api/reports/{report}/export'
*/
ExportReportController.get = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ExportReportController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Report\ExportReportController::__invoke
* @see app/Http/Controllers/Report/ExportReportController.php
* @route '/api/reports/{report}/export'
*/
ExportReportController.head = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ExportReportController.url(args, options),
    method: 'head',
})

export default ExportReportController